import { Route, IndexRoute } from 'react-router';
import * as React from 'react';
import Error404 from '@ordermentum/ui-shared/templates/Error404';
import App from '../components/App';
import { RetailerRegisterConnected as RetailerRegister } from '../components/RetailerRegister';
import { SupplierRegisterConnected as SupplierRegister } from '../components/SupplierRegister';
import { PaymentRequestConnected as PaymentRequest } from '../components/PaymentRequest';
import { PendingActivation } from '../components/Login/PendingActivation';
import { SuccessPage } from '../components/Shared/Success';
import { Success } from '../components/Success';
import { ErrorPage } from '../components/Shared/Error';
import analytics from '../components/Analytics';
import Home from '../components/Home';
import {
  MagicLinkLogin,
  DefaultLogin,
  InvitationLogin,
  PaymentRequestLoginConnected,
  DefaultSignUp,
  DefaultPasswordReset,
  DefaultPasswordResetEntry,
  DefaultPasswordSignUpEntry,
} from '../components/Login';
import { SignupSuccess } from '../components/Login/Forms/Success';
import ifLoggedIn from '../components/Shared/ifLoggedIn';
import { DefaultMFA } from '../components/Login/DefaultMFA';
import { SocialUpgrade } from '../components/Login/SocialUpgrade';
import OutstandingInvoices from '../components/PaymentRequest/OutstandingInvoices';

export default (
  <Route path="/" component={Home}>
    <IndexRoute component={ifLoggedIn(Error404, DefaultLogin)} />
    <Route path="/register">
      <IndexRoute component={analytics(App, 'register')} />
      <Route path="success" component={Success} />
      <Route path="retailer">
        <IndexRoute component={RetailerRegister} />
        <Route
          path="success"
          component={analytics(SuccessPage('retailer'), 'success-retailer')}
        />
        <Route
          path="failure"
          component={analytics(ErrorPage, 'failure-retailer')}
        />
      </Route>
      <Route path="supplier">
        <IndexRoute component={SupplierRegister} />
        <Route
          path="success"
          component={analytics(SuccessPage('supplier'), 'success')}
        />
        <Route path="failure" component={analytics(ErrorPage, 'failure')} />
      </Route>
    </Route>
    <Route path="error" component={Error404} />
    <Route
      path="dashboard/add-supplier/supplier/:supplierId"
      component={MagicLinkLogin}
    />
    <Route path="password-reset" component={DefaultPasswordReset} />
    <Route path="mfa" component={DefaultMFA} />
    <Route path="invites/:id/accept" component={InvitationLogin} />
    <Route path="sign-up">
      <IndexRoute
        component={props => (
          <DefaultSignUp
            {...props}
            registrationSuccessDestination={'/dashboard'}
          />
        )}
      />
      <Route path="success" component={SignupSuccess} />
    </Route>
    <Route path="sign-in" component={DefaultLogin} />
    <Route
      path="sign-up/retailer"
      component={props => (
        <DefaultSignUp
          {...props}
          registrationSuccessDestination={`/register/retailer`}
        />
      )}
    />
    <Route
      path="sign-up/supplier"
      component={props => (
        <DefaultSignUp
          {...props}
          registrationSuccessDestination={`/register/supplier`}
        />
      )}
    />
    <Route path="user/password" component={DefaultPasswordResetEntry} />
    <Route path="user/welcome" component={DefaultPasswordSignUpEntry} />
    <Route path="payments/:retailerId">
      <IndexRoute component={PaymentRequest} />
      <Route path="auth" component={PaymentRequestLoginConnected} />
      <Route path="pending-activation" component={PendingActivation} />
      <Route path="outstanding-invoices" component={OutstandingInvoices} />
    </Route>
    <Route path="social/upgrade" component={SocialUpgrade} />
    <Route path="*" component={ifLoggedIn(Error404, DefaultLogin)} />
  </Route>
);
